export interface ChatButtonOffsetChannel {
  get(): number;
  set(sidebarId: string, width: number): void;
  subscribe(listener: () => void): () => void;
}

// Max of the sidebars' contributed widths, in px — the rule useSidebarWidthCoordinator's
// reduceRight actually implements (its "most recent" comment lies), so the map margin matches.
const createChatButtonOffsetChannel = (): ChatButtonOffsetChannel => {
  const contributions = new Map<string, number>();
  const listeners = new Set<() => void>();
  let effective = 0;

  return {
    get: () => effective,
    set: (sidebarId, width) => {
      if (width > 0) {
        contributions.set(sidebarId, width);
      } else {
        contributions.delete(sidebarId);
      }
      const next = Math.max(0, ...contributions.values());
      if (next !== effective) {
        effective = next;
        listeners.forEach((listener) => listener());
      }
    },
    subscribe: (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
  };
};

export default createChatButtonOffsetChannel;
